const moment = require('moment');

 


export default function getDateFromString(isoDate) {
    if (!isoDate || isNaN(Date.parse(isoDate))) {
        return "N/A";
    }
    //const formattedDate = moment(isoDate).format('DD/MM/YYYY HH:mm');
    const formattedDate = moment(isoDate).format('DD/MM/YYYY');
  
    return formattedDate;
  }

